import { jsx } from 'react/jsx-runtime';
import { cloneElement } from 'react';
import { SideSheet } from '@circlefin/components';
import { useSideSheet } from '../useSideSheet/index.js';

const SideSheetRoute = ({ route, content, hideBack, variant })=>{
    const { current, router, history } = useSideSheet();
    if (current?.route !== route) {
        return null;
    }
    return jsx(SideSheet, {
        hideBack: history.length <= 1 || hideBack,
        onBack: router.back,
        onClose: router.clear,
        variant: variant,
        children: /*#__PURE__*/ cloneElement(content, current.props)
    });
};

export { SideSheetRoute };
//# sourceMappingURL=SideSheetRoute.js.map
